import {
  Box,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import AlertBar from "../../../../components/display/AlertBar";
import { single_box_view_title_size } from "../../SingleBoxView";
import { useFetch } from "../../../../../../hooks/Fetching";
import { useParams } from "react-router-dom";
import NotFound from "../../../../components/display/NotFound";
import { useTranslation } from "react-i18next";
import { THERAPY_ALERTS } from "../../../../../../enums/ApiPaths";
import { ALERTS_IN_BOX } from "../../../../../../enums/QueryKeys";
//This list should be generated automatically on the backend from all the dates connected to this box and then displayed

export default function AlertList() {
  const { id } = useParams();
  const url = THERAPY_ALERTS + id;
  const {t} = useTranslation();
  
  const { data, isLoading, error } = useFetch(
    url,
    null,
    ALERTS_IN_BOX + id
  );

  if (isLoading) {
    return (
      <Wrapper>
        <Skeleton variant="rectangular" height={250} />
      </Wrapper>
    );
  } else if (error) {
    return (
      <Wrapper>
        <NotFound title="Error fetching alerts" />
      </Wrapper>
    );
  }

  const isEmpty = data == null || data?.length == 0;

  return (
    <Wrapper>
      <Box>
        {isEmpty ? (
          <Typography color="grayText" variant="subtitle2">
            {t("NoAlerts")}
          </Typography>
        ) : (
          <Stack spacing={2}>
            {data?.map((alert, index) => (
              <AlertBar
                severity={alert.alertSeverity}
                message={`${alert.endTime} ${String(alert.description)} `}
                key={index}
              />
            ))}
          </Stack>
        )}
      </Box>
    </Wrapper>
  );
}

function Wrapper({ children }) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Typography variant={single_box_view_title_size} gutterBottom>
          {t("AlertsAndNotifications")}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
}
